// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const AuditSummaryCriteriaFooter = props =>
    <div className='audit-summary-criteria-footer'>
        <div className='asterisk-before'>
            <FormattedMessage id='INDICATES_REQUIRED_FIELD'/>
        </div>
        <div className='button-group'>
            <button
                className='secondary-button'
                onClick={props.handleCriteriaReset}
                type='submit'
            >
                <FormattedMessage id='RESET'/>
            </button>
            <button
                className='primary-button'
                disabled={!props.canRunReport}
                onClick={props.onRunReport}
                type='button'
            >
                <FormattedMessage id='EXECUTE'/>
            </button>
        </div>
    </div>;

AuditSummaryCriteriaFooter.displayName = 'AuditSummaryCriteriaFooter';
AuditSummaryCriteriaFooter.propTypes = {
    canRunReport: PropTypes.bool.isRequired,
    handleCriteriaReset: PropTypes.func.isRequired,
    onRunReport: PropTypes.func.isRequired
};

export default AuditSummaryCriteriaFooter;



// WEBPACK FOOTER //
// ./src/reports/audit-summary/components/audit-summary-report-criteria/criteria-footer.js